import React from 'react';
import { styled } from '@compiled/react';
import { graphql, useFragment } from 'react-relay';
import { colors, fontSizeSmall } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles
import { gridSize } from '@atlassian/jira-common-styles/src';
import type { issueTotalCount_softwareReleasesVersionDetailIssueList$key } from '@atlassian/jira-relay/src/__generated__/issueTotalCount_softwareReleasesVersionDetailIssueList.graphql';

interface Props {
	jiraVersion: issueTotalCount_softwareReleasesVersionDetailIssueList$key;
}

export const IssueTotalCount = ({ jiraVersion }: Props) => {
	const data = useFragment(
		graphql`
			fragment issueTotalCount_softwareReleasesVersionDetailIssueList on JiraVersion {
				allIssuesRedesignTemp: issues @required(action: THROW) {
					totalCount @required(action: THROW)
				}
			}
		`,
		jiraVersion,
	);

	return <TotalCountLozenge>{data.allIssuesRedesignTemp.totalCount}</TotalCountLozenge>;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TotalCountLozenge = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: token('color.background.accent.gray.subtlest', colors.N40),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	fontSize: `${fontSizeSmall}px`,
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${gridSize * 2}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	borderRadius: `${gridSize}px`,
	// This margin is to align vertically, due to font style, 2 pixels are misaligned that looks not right.
	marginTop: token('space.025', '2px'),
	paddingRight: token('space.050', '4px'),
	paddingLeft: token('space.050', '4px'),
});
